const currencySwitcher = () => {
  const currencyElements = document.querySelectorAll('.currency-switcher__country');
  currencyElements.forEach(element => {
    element.addEventListener('click', e => {
      e.preventDefault();
      const currentDomain = window.location.origin;
      const targetDomain = element.href.split('?')[0].replace('/us', '').replace('/en', '');
      const currentUrl = window.location.href.replace('/fr', '').replace('/de', '').replace('/it', '');
      let newUrl = currentUrl.replace(currentDomain, targetDomain);
      const queryString = element.href.split('?')[1];
      if (queryString) newUrl += newUrl.includes('?') ? '&' + queryString : '?' + queryString;
      window.location.href = newUrl;
    });
  });
};
currencySwitcher();